import React from "react";
import Nav from "./Nav";
import { Carousel } from "antd";

const Services = () => {
  return (
    <>
      <main id="main" className="bg-img">
        <div id="bgImg">
          <div className="container">
            <Nav />

            <div className="content">
              {/* <section id="testim" className="testim" style={{ marginTop: "-41px" }}>
                                <div className="wrap">
                                    <span id="right-arrow" className="arrow right fa fa-chevron-right d-none"></span>
                                    <span id="left-arrow" className="arrow left fa fa-chevron-left d-none"></span>
                                    <ul id="testim-dots" className="dots">
                                        <li className="dot active"></li>
                                    </ul>

                                    <div id="testim-content" className="cont">


                                        <div>
                                            <span>SERVICES</span>
                                            <h1>SERVICES</h1>
                                            <h2>UX, UI DESIGN</h2>
                                            <p>The designer does a strategic plan for the platform to<br /> improve its user
                                                experience and then designs the user<br /> interface.</p>
                                        </div>

                                        <div>
                                            <span>SERVICES</span>
                                            <h1>SERVICES</h1>
                                            <h2>GRAPHIC DESIGNER</h2>
                                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                                incididunt ut labore
                                                et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                                                ullamco.</p>
                                        </div>

                                    </div>
                                </div>
                            </section> */}

              <span>SERVICES</span>
              <h1>SERVICES</h1>

              <Carousel autoplay autoplaySpeed={5000}>
                <div>
                  <h2 className="fs-5" style={{ color: "#FFDC64" }}>
                    WEB DEVELOPMENT
                  </h2>
                  <p className="ms-0">
                    Transforming visions into captivating online experiences,
                    our web development services at PERFECT blend creativity
                    with functionality. We craft custom, responsive websites
                    optimized for seamless user experiences and enhanced search
                    engine visibility. Partner with us to elevate your digital
                    presence and achieve measurable results.
                  </p>
                </div>
                <div>
                  <h2 className="fs-5" style={{ color: "#FFDC64" }}>
                    Mobile Application Development
                  </h2>
                  <p className="ms-0">
                    Creating dynamic and intuitive mobile applications, PERFECT
                    merges innovation with user-centric design to realize your
                    mobile vision. We specialize in crafting bespoke mobile apps
                    that captivate users and propel business success.
                    Collaborate with us to build seamless mobile experiences
                    tailored to your brand, driving engagement and achieving
                    measurable outcomes.
                  </p>
                </div>
                <div>
                  <h2 className="fs-5" style={{ color: "#FFDC64" }}>
                    UX, UI DESIGN
                  </h2>
                  <p className="ms-0">
                    Crafting seamless user experiences and stunning user
                    interfaces, PERFECT leverages Adobe XD to bring your digital
                    vision to life. We specialize in designing intuitive
                    interfaces that prioritize user engagement and satisfaction.
                    Partner with us to create visually captivating and
                    user-friendly experiences that elevate your brand and drive
                    results.
                  </p>
                </div>
                {/* <div>
                  <h2 className="fs-5" style={{ color: "#FFDC64" }}>
                    Emerging Technologies
                  </h2>
                  <p className="ms-0">
                    Embrace the future with our expertise in emerging
                    technologies such as artificial intelligence. We help you
                    harness the power of these cutting-edge innovations to drive
                    efficiency, innovation, and competitive advantage.
                  </p>
                </div> */}
                {/* <div>
                                    <h2 className='fs-5' style={{ color: "#FFDC64" }}>Software Consulting</h2>
                                    <p className='ms-0'>Gain strategic insights and expert guidance with our software consulting services. From project planning and architecture design to technology selection and implementation, we provide tailored solutions to help you navigate the complexities of software development.</p>
                                </div> */}
              </Carousel>
            </div>

            <div className="social-media mt-5">
              <a href="https://www.facebook.com/Perfect-151150445074122">
                <img src="img/facebook.png" />
              </a>
              <a href="https://www.instagram.com/perfect94446783/?fbclid=IwAR14fVz3P2rQ5x8Y8sAlERhd1ldCJhGDPt8M1KAoDsH3sO-y_vDRKNy4Yqg">
                <img src="img/instagram.png" />
              </a>
              <a href="https://www.youtube.com/channel/UC-RBwShQdGVl8aQCo2tyHnA/featured">
                <img src="img/youtube.png" />
              </a>

              <span>SOCIAL MEDIA</span>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Services;
